import React from 'react';
import styles from './LayerControls.module.css';

const LayerControls = ({ showLabels, showShapes, onToggleLabels, onToggleShapes }) => {
  return (
    <div className={styles.controls}>
      <button 
        className={`${styles.button} ${showLabels ? styles.active : ''}`}
        onClick={onToggleLabels}
        title={showLabels ? "İsimleri Gizle" : "İsimleri Göster"}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <path d="M14 2v6h6"/>
          <path d="M16 13H8"/>
          <path d="M16 17H8"/>
          <path d="M10 9H8"/>
        </svg>
      </button>
      <button 
        className={`${styles.button} ${showShapes ? styles.active : ''}`}
        onClick={onToggleShapes}
        title={showShapes ? "Şekilleri Gizle" : "Şekilleri Göster"}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
          <circle cx="12" cy="10" r="3"/>
        </svg>
      </button>
    </div>
  );
};

export default LayerControls;

